var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRisksSuggestionPeople = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 8.08732C8.49063 12.9707 15.5095 12.9695 15.6664 8.08723C15.5113 3.1917 8.48739 3.19283 8.33301 8.08732Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1907 18.0599C17.1177 11.5192 8.27698 10.5427 6.92471 16.9136C6.73532 17.6596 6.83501 19.2229 6.81061 19.9994L17.1907 19.9994L17.1907 18.0599Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66259 8.08301C1.00142 8.17773 1.00214 13.4888 4.66268 13.583C8.33552 13.4905 8.3348 8.17507 4.66259 8.08301Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99563 18.059C5.99699 17.0221 6.23918 15.9942 6.69631 15.0765C4.24563 13.5538 0.927359 15.6068 1.00121 18.6279C1.00114 18.6279 1.00114 19.9984 1.00114 19.9984H5.99562V18.059H5.99563Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3374 13.583C22.9986 13.4883 22.9979 8.17721 19.3374 8.08301C15.6645 8.17559 15.6652 13.491 19.3374 13.583Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9989 19.9996V18.629C23.0417 16.4471 21.2317 14.5227 19.1613 14.5692C18.5014 14.5691 17.8659 14.7416 17.3037 15.0777C17.4422 15.3622 17.5644 15.6552 17.6704 15.9569C17.887 16.6328 18.0023 17.3459 18.0044 18.0601L18.0044 19.9996L22.9989 19.9996Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRisksSuggestionPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risks_suggestion_people.e7801aedc235246178ff7613a8475c52.svg";